import { CLASS_IS_LOADING, ASSETS_PATH, CLASS_IS_DISABLED } from "../../global/base";

// TODO refactor for many btn loaders in one class

export default class Loader {
    constructor(type) {
        this.loading = false;
        this.created = false;
        this.div = null;
        this.imgSrc = ASSETS_PATH + '/images/shared/loader.gif';

        if (!type || type !== 'button') {
            this.imgEl = this.createImageEl(); // preload image
        }
    }

    show(wrapper, buttonType) {

        if (wrapper && !this.loading) {
            this.loading = true;
            // wrapper.style.transform = 'translateX(0)';
            if (buttonType) {
                wrapper.appendChild(this.createButtonLoader());
                wrapper.classList.add(CLASS_IS_DISABLED);
            }
            else {
                wrapper.appendChild(this.createLoader());
            }
            wrapper.classList.add(CLASS_IS_LOADING);
        }

    }

    hide() {
        if (this.div) {
            this.div.parentNode.classList.remove(CLASS_IS_LOADING);
            this.div.parentNode.classList.remove(CLASS_IS_DISABLED);
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
        this.loading = false;
    }


    createLoader() {
        if (!this.div) {
            this.div = document.createElement('div');
            this.div.classList.add('Loader-gif');
            this.div.appendChild(this.createImageEl());
        }
        return this.div;
    }

    createButtonLoader() {
        if (!this.div) {
            this.div = document.createElement('div');
            const innerWrapper = document.createElement('div');
            innerWrapper.classList.add('Loader__container');
            for (let i = 0; i < 8; i++) {
                let innerEl = document.createElement('span');
                innerEl.classList.add('Loader__elem');
                innerWrapper.appendChild(innerEl);
            }
            this.div.appendChild(innerWrapper);
            this.div.classList.add('Loader');
        }
        return this.div;
    }

    createImageEl() {
        if (!this.imgEl) {
            this.imgEl = document.createElement('img');
            this.imgEl.setAttribute('src', this.imgSrc);
            this.imgEl.setAttribute('alt', 'loader');
        }
        return this.imgEl;
    }

    message(msg) {
        if (this.div) {
            this.div.innerText = msg;
        }
    }
}
